import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    minHeight: '19px'
  },

  container: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },

  icon: {
    cursor: 'pointer'
  }
}))

export default useStyles
